<div class="ispm-lab-order-container">
    <div class="form-actions" *ngIf="selectedOrder">
        <div *ngIf="contactDetails" class="contact-details-container">
            <span class="contact-details-note">
                {{contactDetails.contactNote}}
            </span>
            <div class="contact-details-info">
                <span *ngFor="let contact of contactDetails.contactAt; let lastChild = last">
                    {{contact.label + ': ' + contact.value}}
                    {{lastChild ? '' : contactDetails.contactSeparator}}
                </span>
            </div>
        </div>
        <div class="form-actions-container">
            <gen-button id="saveOrderContentBtn" class="save-button" [ngClass]="" [disabled]="!canUserWrite()"
                        (click)="savePartialOrderContent()" [type]="'secondary'" [text]="'Save'" genTooltip
                        [tooltipPosition]="'BOTTOM'" [appendToBody]="true" [iconClass]="">
            </gen-button>
            <gen-button id="saveAndSubmitOrderContentBtn" class="save-button"
                        [disabled]="!canUserWrite()" [ngClass]="" [type]="'primary'" [text]="'Submit'"
                        (click)="saveOrderContent()" genTooltip [tooltipPosition]="'BOTTOM'" [appendToBody]="true" [iconClass]="">
            </gen-button>
        </div>
    </div>
    <div class="redraw-status" *ngIf="selectedOrder">
        <div *ngIf="redrawDetails" class="redraw-details-container">
            <div class="redraw-details-info">
                <i class="fa fa-exclamation-circle fa-2x redraw-icon" aria-hidden="true"></i>
                <span class="redraw-label">Test Redrawn - </span>
                <span class="redraw-text">{{redrawDetails}}</span>
            </div>
        </div>
    </div>
    <div>
        <div class="order-dynamic-forms-container " *ngIf="selectedOrder; else noSelectedOrder">
            <div class="order-dynamic-form-item {{selectedOrder?.status?.code}}"
                 [ngClass]="{'event-form-half-width': formConfig?.formHalfWidth}"
                 [ngStyle]="{'width': formConfig?.formWidth}"
                 *ngFor="let formConfig of _orderFormConfigs; let i = index">
                <span class="top-panel titles">{{formConfig.title}}</span>
                <gen-dynamic-form class="info-dynamic-form" [popupMode]="false" [formName]="formConfig?.formId"
                                  [editMode]="true" (validateChange)="isFormValid = $event" [formVertical]="true"
                                  [disabled]="!canUserWrite()" [disabledForced]="!canUserWrite()" [listenToDataChange]="true"
                                  [requiredMessage]="''" [requiredMessage]="''" (formChange)="updateFormData($event, i)"
                                  [ngClass]="(hasUpdatedFields)? 'footer-show':'footer-close'"></gen-dynamic-form>
            </div>
        </div>
    </div>

    <ng-template #noSelectedOrder>
        <div class="no-data-text">
            No Data Available
        </div>
    </ng-template>

</div>
